<template>
  <div>
    <canvas ref="chartCanvasRef"></canvas>
  </div>
</template>
<script>
import { Chart } from 'chart.js'
import { formatAccounting } from '../../../lib/utils'

export default {
  name: 'SalesChartV2',
  props: {
    data: {
      type: Object,
      default: () => ({
        labels: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
        sales: [0, 0, 0, 0, 0, 0, 0],
        purchases: [0, 0, 0, 0, 0, 0, 0],
        loans: [0, 0, 0, 0, 0, 0, 0],
        expenses: [0, 0, 0, 0, 0, 0, 0],
        losses: [0, 0, 0, 0, 0, 0, 0],
        collections: [0, 0, 0, 0, 0, 0, 0],
      }),
    },
  },
  data() {
    return {
      chart: null,
      config: {
        type: 'line',
        data: {
          labels: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
          datasets: [
            {
              tension: 0.1,
              label: 'Sales',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(108, 185, 111, 0.9)',
              borderColor: 'rgba(37, 63, 38, 0.9)',
              // backgroundColor: 'rgba(76, 175, 80, 0.5)',
              borderWidth: 1,
              fill: false,
            },
            {
              tension: 0.1,
              label: 'Purchases',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(255, 201, 123, 0.9)',
              borderColor: 'rgba(85, 50, 0, 0.9)',
              // backgroundColor: 'rgba(255, 152, 0, 0.5)',
              borderWidth: 1,
              fill: false,
            },
            {
              tension: 0.1,
              label: 'Losses',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(152, 48, 39, 0.9)',
              borderColor: 'rgba(52, 16, 13, 0.9)',
              // backgroundColor: 'rgba(156, 50, 40, 0.5)',
              borderWidth: 1,
              fill: false,
            },
            {
              tension: 0.1,
              label: 'Collections',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(189, 73, 213, 0.9)',
              borderColor: 'rgba(74, 28, 84, 0.9)',
              // backgroundColor: 'rgba(224, 86, 253, 0.5)',
              borderWidth: 1,
              fill: false,
            },
            {
              tension: 0.1,
              label: 'Expenses',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(54, 0, 0, 0.9)',
              borderColor: 'rgba(164, 0, 0, 0.9)',
              // backgroundColor: 'rgba(247, 0, 0, 0.5)',
              borderWidth: 1,
              fill: false,
            },
          ],
        },
        options: {
          legend: {
            labels: {
              fontColor: '#666',
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || ''
                const value = formatAccounting(tooltipItem.yLabel)
                return `${datasetLabel}: ${value}`
              },
            },
          },
          scales: {
            xAxes: [
              {
                type: 'category',
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: (val) => {
                    return formatAccounting(val)
                  },
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      },
    }
  },
  mounted() {
    const canvas = this.$refs.chartCanvasRef
    this.chart = new Chart(canvas, {
      ...this.config,
    })
    this.update()
  },
  methods: {
    update() {
      const config = { ...this.config }
      config.data.labels = [...this.data.labels]
      config.data.datasets[0].data = [...this.data.sales]
      config.data.datasets[1].data = [...this.data.purchases]
      config.data.datasets[2].data = [...this.data.losses]
      config.data.datasets[3].data = [...this.data.collections]
      config.data.datasets[4].data = [...this.data.expenses]
      this.config = config
      this.chart.data = config.data
      this.chart.update()
    },
  },
}
</script>
